import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { useForm } from "react-hook-form";

import WSTextField from "../../../Components/TextBox/WSTextBox";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";

const Unit = () => {
   const [loading, setLoading] = useState(false);
     const [isEditMode, setIsEditMode] = useState(false);
      const [selectedId, setSelectedId] = useState<string | number>(0);
      const [isPopupOpen, setPopupOpen] = useState(false);
      const { showMessage } = useSnackbar();
      const params = useParams();
      const id = params.id;
      const navigate = useNavigate();


      const location = useLocation();
          const from = location.state?.from;
  
      const {
          control,
          handleSubmit,
          reset,
          formState: { isValid },
        } = useForm({
          mode: "onChange",
          defaultValues: {
            UnitName: "",
            Symbol: "",
            IsActive: true,
          },
        });
      
        useEffect(() => {
      
          if (!id || id === "undefined" || id === "null" || id.trim() === "") {
            setIsEditMode(false);
            reset();
            return;
          }
      
          setIsEditMode(true);
          fetchunitData(id);
        }, [id, showMessage, reset]);
  
  
        const fetchunitData = async (unitId: string) => {
            try {
              setLoading(true);
        
              const response = await callAPI(`units/${unitId}`, Method.GET);
        
              if (response?.success && response.data) {
                const unitData = response.data;
        
                reset({
                  UnitName: unitData.UnitName || "",
                  Symbol: unitData.Symbol || "",
                  IsActive: unitData.IsActive !== false,
                });
              } else {
                console.error("❌ No data in response:", response);
                showMessage(response?.message || `Warehouse ${unitId} not found`, "error");
                setIsEditMode(false);
              }
            } catch (error: any) {
              console.error("❌ Fetch error:", error.response?.data || error.message);
              showMessage("Failed to load warehouse data", "error");
              setIsEditMode(false);
            } finally {
              setLoading(false);
            }
          };
        
  
           const onSubmit = async (data: any) => {
              try {
                setLoading(true);
                const requestBody = {
                  UnitName: data.UnitName?.trim(),
                  Symbol: data.Symbol || "",
                  
                  IsActive: data.IsActive || true,
                };
          
          
                let response;
                if (isEditMode && id) {
                  response = await callAPI(`units/${id}`, Method.PUT, requestBody);
                } else {
                  response = await callAPI("units/create", Method.POST, requestBody);
                }
          
                if (response?.success) {
                  showMessage(
                    isEditMode
                      ? "unit updated successfully!"
                      : "unit created successfully!",
                    "success"
                  );
                  // navigate("/unit/list");

                   if (response?.success) {
  if (from === "itemmaster") {
    navigate("/itemmaster");
  } else if (from === "adjustment") {
    navigate("/adjustment");
  }
  else if (from === "verification") {
    navigate("/verification");
  } 
  else if (from === "stock-return") {
    navigate("/stock-return");
  } 
   else {
    navigate("/unit/list");
  }
}
                } else {
                  showMessage(response?.message || "Operation failed", "error");
                }
              } catch (error: any) {
                console.error("❌ Submit error:", error);
                showMessage(error?.message || "Operation failed", "error");
              } finally {
                setLoading(false);
              }
            };
          
            const handleDeleteClick = () => {
              if (!id) return;
              setSelectedId(id);
              setPopupOpen(true);
            };
          
            const handleBack = () => {
              navigate("/unit/list");
            };
    
  return (
   <Box sx={{ p: 2, background: "#f0f0f0", minHeight: "100vh" }}>
      {}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Box display="flex" alignItems="center" gap={2}>
          
          <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
            {isEditMode ? "Edit Unit" : "Unit Management"}
          </Typography>
        </Box>

        <Box>
             
                    {isEditMode && (
                        <IconButton 
                            sx={{ background: "black", color: "#fff" }}
                            onClick={handleDeleteClick}
                            disabled={loading}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    )}

          
        </Box>
      </Box>

      {}
      <Paper
        sx={{
          borderRadius: "16px",
          p: 3,
          background: "#fafafa",
          position: "relative",
        }}
      >

        {}
        <Box display="flex" justifyContent="space-between" mb={7}>
          <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
            {isEditMode ? "Unit Details" : "Unit Details"}
          </Typography>
           <Tooltip title={isEditMode ? "Update Unit" : "Create Unit"} arrow>
            <IconButton
              sx={{ background: "#000", color: "#fff" }}
              onClick={handleSubmit(onSubmit)}
              disabled={!isValid || loading}
            >
              <SaveIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>

        <form noValidate>
         <Grid container rowSpacing={8} columnSpacing={5}>
          
          <Grid item xs={4}>
            <WSTextField
              name="UnitName"
              label="Unit Name"
              id="UnitName"
              control={control}
             
            />
          </Grid>

          {}
         

          <Grid item xs={4}>
            <WSTextField
              name="Symbol"
              label="Symbol"
              id="Symbol"
              control={control}
              
            />
          </Grid>

        </Grid>
        </form>
      </Paper>

      {}
      <ConfirmationPopup
        type="DELETE"
        apiUrl="units" 
        id={selectedId}
        confirmMessage="Are you sure you want to delete this Unit?"
        open={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        onConfirm={async (data) => {
          if (!selectedId) return;

          if (data?.success === true) {
            // Optional: clear grid / state
            // dispatch(resetDataComponent("warehouseGrid")); // uncomment if you use Redux

            showMessage("Unit deleted successfully!", "success");
            navigate("/unit/list");
          } else {
            showMessage(data?.detail, "error");
          }

          setPopupOpen(false);
        }}
      />
    </Box>
  );
};

export default Unit;
